/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import './toast.scss';

export class ToasterMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: {},
            showMessage: false
        }
    }

    /**
     * 
     * @param {{ type: string, message: string }} message Cotaining required data 
     * 
     * @param {number} delay Delay for close
     * 
     * @param {boolean} dontHide Show until
     * 
     */
    showMessage = (message, delay = 3000, dontHide = false) => {
        this.setState({
            message: message,
            showMessage: true
        }, () => {
            if (!dontHide) {
                this.hideMessage(delay);
            }
        });
    }

    hideMessage = (delay = 3000) => {
        setTimeout(() => {
            this.setState({
                showMessage: false
            });
        }, delay);
    }

    render() {
        return (
            <div className={`${this.props.className ? this.props.className : ''} custom-toaster ${this.state.message.type} ${this.state.showMessage ? '' : 'd-none'}`}>
                <div className="d-flex align-items-center">
                    <div className="icon">
                        {
                            this.state.message.type === 'success' ?
                                <i className="far fa-check-circle h5"></i> :
                                this.state.message.type === 'danger' ?
                                    <i className="far fa-times-circle h5"></i> :
                                    this.state.message.type === 'info' ?
                                        <i className="fas fa-info-circle h5"></i> : null
                        }
                    </div>
                    <div className="message h5">
                        {this.state.message.message}
                    </div>
                </div>
            </div>
        );
    }
}

export default ToasterMessage;